
import { Button } from '../../components/button';
import { cn } from '@univdiam/ui/lib/utils';

type OptionButtonProps = {
  label: string;
  isSelected: boolean;
  onClick: () => void;
  disabled?: boolean;
}

export const OptionButton: React.FC<OptionButtonProps> = ({ label, isSelected, onClick, disabled }) => {
  return (
    <Button
      type="button"
      variant={isSelected ? 'default' : 'outline'}
      size="sm"
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      className={cn(
        'rounded-full font-medium whitespace-nowrap',
        !isSelected && !disabled && 'text-muted-foreground'
      )}
    >
      {label}
    </Button>
  );
};
